var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"car-intro"}},[_c('div',{attrs:{"id":"text-block"}},[_c('body',{attrs:{"id":"car-name-header"}},[_vm._v(" PRESENTING OUR 2026 CAR ")]),_c('h1',{attrs:{"id":"car-name"}},[_vm._v(" ORIGIN ")])]),_c('img',{attrs:{"id":"car-image","src":require("@/assets/race26/DSC_1972.JPG")}})])
}]

export { render, staticRenderFns }